<!-- Translated: skip -->
<template>
    <div :class="'notification ' + colorClass + ' ' + alignClass" role="note">
        <component :is="elementTag" v-if="title">{{ title }}</component>
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'center',
    },
    color: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'strong',
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    colorClass() {
      if (this.color === 'blue') {
        return 'notification--blue';
      }

      return '';
    },
    alignClass() {
      if (this.align === 'center') {
        return 'center';
      }

      return '';
    },
    elementTag() {
      return this.tag;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.notification
  info-box()

  &.notification--blue
    info-box--blue()
</style>



// WEBPACK FOOTER //
// Note.vue?5632767d